export type RegisterViewKey =
  | 'all'
  | 'mine'
  | 'critical-high'
  | 'review-overdue'
  // Archived rows are excluded from every other view, so without this one
  // the Restore control on an archived risk's peek is only reachable by
  // hand-building /risks?selected=<uuid>.
  | 'archived';

export interface SavedView {
  id: string;
  name: string;
  view: RegisterViewKey;
  search: string;
  ordering: string;
}

const storageKey = (userId: string) => `register-views:${userId}`;

export function loadSavedViews(userId: string): SavedView[] {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveSavedViews(userId: string, views: SavedView[]): void {
  localStorage.setItem(storageKey(userId), JSON.stringify(views));
}
